export const ADD_ROUTE_TO_HISTORY_ACTION = 'ADD_ROUTE_TO_HISTORY_ACTION';
